import * as React from 'react';

import { useThemeVariable } from '@lyearn/style';

const DEFAULT_STROKE_COLOR = '#56B06C';

export interface PartialTickCircleProps extends React.SVGProps<SVGSVGElement> {
  strokeColorToken?: string;
}

function SvgPartialTickCircle(props: PartialTickCircleProps, ref: React.Ref<SVGSVGElement>) {
  const { className, strokeColorToken, ...rest } = props;
  const themeStroke = useThemeVariable(strokeColorToken ?? '');
  const stroke = strokeColorToken ? themeStroke : DEFAULT_STROKE_COLOR;

  return (
    <svg
      ref={ref}
      className={className}
      fill="none"
      height={17}
      stroke={stroke}
      // The path data only spans ~[1, 16] of a naive "0 0 17 17" box, but the
      // rendered stroke (2.125 wide, round caps) bleeds past that, filling the
      // box edge-to-edge — unlike @lyearn/icons' outline icons, which keep the
      // artwork within ~83% of their viewBox. This wider viewBox adds that same
      // quiet space back in without touching the path data.
      viewBox="-1.4 -1.5 20 20"
      width={17}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <path
        d="M2.1459 4.63477C1.75622 5.27365 1.46016 5.9759 1.27686 6.72238"
        strokeLinecap="round"
        strokeWidth={2.125}
      />
      <path
        d="M1.27295 10.2617C1.4548 11.0097 1.74977 11.7135 2.13872 12.3539"
        strokeLinecap="round"
        strokeWidth={2.125}
      />
      <path
        d="M4.6416 14.8594C5.28175 15.2485 5.9853 15.5439 6.73307 15.7262"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.125}
      />
      <path
        d="M10.2667 1.27344C13.5214 2.06648 15.9373 5.001 15.9373 8.49979C15.9373 11.9986 13.5213 14.9332 10.2666 15.7262"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.125}
      />
      <path
        d="M6.73322 1.27344C5.99014 1.45455 5.29073 1.74733 4.65381 2.13297"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.125}
      />
      <path
        d="M5.30859 9.20768L7.43784 11.3327L11.6921 5.66602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.125}
      />
    </svg>
  );
}

export default React.forwardRef(SvgPartialTickCircle);
